export var SkillTypes;
(function (SkillTypes) {
    SkillTypes["SPEAKING"] = "Speaking";
    SkillTypes["LISTENING"] = "Listening";
    SkillTypes["READING"] = "Reading";
    SkillTypes["WRITING"] = "Writing";
    SkillTypes["OVERALL_SCORE"] = "Overall Score";
    SkillTypes["CEFR"] = "CEFR";
})(SkillTypes || (SkillTypes = {}));
export var OrderStatuses;
(function (OrderStatuses) {
    OrderStatuses["PENDING"] = "PENDING";
    OrderStatuses["REJECTED"] = "REJECTED";
    OrderStatuses["PAID"] = "PAID";
    OrderStatuses["FULFILLED"] = "FULFILLED";
    OrderStatuses["REFUNDED"] = "REFUNDED";
    OrderStatuses["PARTIALLY_REFUNDED"] = "PARTIALLY_REFUNDED";
    OrderStatuses["CANCELLED"] = "CANCELLED";
    OrderStatuses["ERROR"] = "ERROR";
    OrderStatuses["DENIED"] = "DENIED";
})(OrderStatuses || (OrderStatuses = {}));
//# sourceMappingURL=common.interfaces.js.map